import { useReferralApplicationMutation } from "api/referral/referral.mutation";
import CheckboxField from "components/CheckBoxField";
import { Button } from "components/LoadingButton";
import { Modal } from "components/Modal";
import { handleError } from "functions/apiHandleError";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import classes from "./style.module.scss";

const ApplicationReferralModal = ({ open, onClose, selectedApplication, staffs }) => {
  const { control, getValues, reset } = useForm({
    mode: "onChange",
  });

  const referralApplicationMutation = useReferralApplicationMutation();

  const handleClose = () => {
    reset();
    onClose();
  };
  const handleSubmitForm = async () => {
    try {
      const selectedStaffs = [];
      for (const key of Object.keys(getValues())) {
        if (getValues()[key]) {
          selectedStaffs.push(key.split("_")[1]);
        }
      }
      await referralApplicationMutation.mutateAsync({
        application: selectedApplication.id,
        destination_users: selectedStaffs,
      });
      toast.success("با موفقیت ارجاع داده شد");
      handleClose();
    } catch (err) {
      handleError({ err });
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="لطفا اشخاص مورد نظر را انتخاب کنید"
      maxWidth="sm"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={referralApplicationMutation.isPending}
            color="success"
            onClick={handleSubmitForm}
          >
            ثبت
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={handleClose}>
            بستن
          </Button>
        </>
      }
    >
      <div className={classes.stuffList}>
        {staffs?.map((item, index) => (
          <CheckboxField
            key={index}
            label={`${item.full_name} (${item.role_display}${
              ["superuser", "faculty_director"].includes(item.role)
                ? ""
                : " " + item?.fields_display
            })`}
            name={`user_${item.id}`}
            control={control}
          />
        ))}
      </div>
    </Modal>
  );
};

export default ApplicationReferralModal;
